import { z } from 'zod';

import { ReferenceSchema } from '../../base';
import { StringSchema } from '../../base/primitives';
import { FunctionSchema } from '../functions/function.schema';

export const SpecialFunctionReferencesSchema = z.object({
  variables: ReferenceSchema,
});

// ============================================================================
// Property Schemas (Reusable across command, form, and projection schemas)
// ============================================================================

// Special function schema extends function but without references and latency control
// Description is optional for special functions unlike regular functions
export const SpecialFunctionSchema = FunctionSchema.omit({
  description: true,
  references: true,
  latencyControl: true,
})
  .extend({
    description: StringSchema,
    references: SpecialFunctionReferencesSchema,
  })
  .describe(
    'Special function used for start/end of conversation handlers. ' +
      'Similar to regular functions but without references or latency control. ' +
      'Description is optional.',
  );

export const SpecialFunctionsStateSchema = z
  .object({
    startFunction: SpecialFunctionSchema.optional().describe(
      'Function executed at the start of every conversation. ' +
        'Used for initialization logic like setting variables or logging.',
    ),
    endFunction: SpecialFunctionSchema.optional().describe(
      'Function executed at the end of every conversation. ' +
        'Used for cleanup logic like saving data or sending notifications.',
    ),
  })
  .describe(
    'Collection of special lifecycle functions for conversations. ' +
      'These execute automatically at conversation start/end.',
  );

export type SpecialFunction = z.infer<typeof SpecialFunctionSchema>;
export type SpecialFunctionsState = z.infer<typeof SpecialFunctionsStateSchema>;
